import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { ApiKey } from '../../../../../../../../../typings/ApiKey.interface';
import { ApiKeyScopeFormValues, ApiKeyScopesFields, buildOrganizationApiKeyScopesPayload, getInitialScopeValues, organizationScopeProjectTypes } from '../../../../../common/ApiKeys/ApiKeyScopesFields';
import { ProjectAccessFields } from '../../../../../common/ApiKeys/ProjectAccessFields';
import TextInput from '../../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Modal from '../../../../../common/Modal';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { DashboardContext } from '../../../DashboardContext';
interface FormValues extends ApiKeyScopeFormValues {
  label: string;
  project_access: string;
  project_ids: string[];
}
interface Props {
  onApiKeyCreated: (api_key: ApiKey) => void;
}
const AddOrganizationApiKeyModal: React.FC<Props> = t0 => {
  const $ = _c(22);
  const {
    onApiKeyCreated
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    organization,
    team,
    teams
  } = useContext(DashboardContext);
  const history = useHistory();
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  organization?.id;
  let t1;
  if ($[0] !== organization?.id || $[1] !== teams) {
    let t2;
    if ($[3] !== organization?.id) {
      t2 = org_team => org_team.organization_id === organization?.id;
      $[3] = organization?.id;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = (teams ?? []).filter(t2).map(_temp);
    $[0] = organization?.id;
    $[1] = teams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const project_options = t1;
  let t2;
  if ($[5] !== history || $[6] !== location.search) {
    t2 = () => {
      history.push({
        pathname: "/settings/organization/api-keys",
        search: location.search,
        state: {
          scroll: false
        }
      });
    };
    $[5] = history;
    $[6] = location.search;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onClose = t2;
  const validate = _temp2;
  let t3;
  if ($[8] !== HookdeckAPI || $[9] !== addToast || $[10] !== onApiKeyCreated || $[11] !== onClose || $[12] !== project_options) {
    t3 = async values_0 => {
      ;
      try {
        const api_key = await HookdeckAPI.organizations.createApiKey({
          label: values_0.label.trim(),
          type: "organization",
          ...buildOrganizationApiKeyScopesPayload(values_0, project_options)
        });
        onApiKeyCreated(api_key);
        addToast("success", "API key created");
        onClose();
      } catch (t4) {
        const err = t4;
        addToast("error", err.message);
      }
    };
    $[8] = HookdeckAPI;
    $[9] = addToast;
    $[10] = onApiKeyCreated;
    $[11] = onClose;
    $[12] = project_options;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const onSubmit = t3;
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      label: "",
      project_access: "all",
      project_ids: [],
      ...getInitialScopeValues("organization")
    };
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== onClose || $[16] !== project_options || $[17] !== team?.id) {
    t5 = props => <form onSubmit={props.handleSubmit}><Modal title="Create Organization API Key" submit_label="Create Organization API Key" cancel_label="Cancel" hide_close={true} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose} is_submitting={props.isSubmitting} submit_disabled={!props.isValid}><Div flex={{
          direction: "column",
          gap: 0
        }}><TextInput name="label" label="Name" placeholder="e.g. CI pipeline" auto_complete="off" focus={true} /><Div m={{
            b: 4
          }}><ProjectAccessFields projects={project_options} current_project_id={team?.id} /></Div><ApiKeyScopesFields tier="organization" project_types={organizationScopeProjectTypes(props.values, project_options)} /></Div></Modal></form>;
    $[15] = onClose;
    $[16] = project_options;
    $[17] = team?.id;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== onSubmit || $[20] !== t5) {
    t6 = <Formik initialValues={t4} onSubmit={onSubmit} validate={validate} validateOnMount={true}>{t5}</Formik>;
    $[19] = onSubmit;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
export default AddOrganizationApiKeyModal;
function _temp(org_team_0) {
  return {
    id: org_team_0.id,
    name: org_team_0.name,
    type: org_team_0.type
  };
}
function _temp2(values) {
  const errors = {};
  if (!values.label?.trim()) {
    errors.label = "Required";
  }
  if (values.project_access === "selected" && values.project_ids.length === 0) {
    errors.project_ids = "Select at least one project";
  }
  return errors;
}